import React from 'react';
import { Avatar, Icon, ListItem, ListItemAvatar, ListItemIcon, ListItemText, styled } from '@mui/material';

const StyledListItem = styled(ListItem)(({ theme }) => ({
	backgroundColor: theme.palette.background.default,
	display: 'flex',
	alignItems: 'center',
	padding: theme.spacing(0.5),
	'&:hover': {
		backgroundColor: theme.palette.background.default,
		opacity: 0.7,
		cursor: 'pointer'
	}
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
	margin: theme.spacing(0.5),
	fontSize: 14
}));

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'center'
}));

export const NewUserAccount = (props: { onClick?: () => void }) => {
	const { onClick } = props;

	function handleClick() {
		if (onClick) {
			onClick();
		}
	}

	return (
		<StyledListItem onClick={handleClick}>
			<ListItemAvatar>
				<StyledAvatar alt='New Account Icon'>
					<StyledListItemIcon>
						<Icon>person_add</Icon>
					</StyledListItemIcon>
				</StyledAvatar>
			</ListItemAvatar>
			<ListItemText primary='Sign in with a different account' primaryTypographyProps={{
				whiteSpace: 'nowrap',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				width: '100%',
				fontSize: 13
			}} />
		</StyledListItem>
	);
};
